// Crawlers and headless browsers must not trigger live network checks: each visit would be a
// real check from our servers. Real visitors get an automatic check on per-domain pages.
const BOT_UA = /bot|crawl|spider|slurp|bingpreview|facebookexternalhit|headless|lighthouse|pagespeed/i

export function isAutomatedVisitor(): boolean {
  if (typeof navigator === 'undefined') return true
  return navigator.webdriver === true || BOT_UA.test(navigator.userAgent)
}
